import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from '../create/components/club-form.schema';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { ClubForm } from '../create/components/club-form';
import { useUpdateClubMutation } from '../mutations';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { useClubQuery } from '../queries';

export const Page = withPrivateRoute(() => {
  const mutation = useUpdateClubMutation();
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);
  const { data } = useClubQuery(id);

  async function onSubmit(payload: Partial<Schema>) {
    const { data } = await mutation.mutateAsync({ id, data: payload });
    navigate(`../${data.id}`);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera förening" />

      <PageLayout.Section>
        <ClubForm
          defaultValues={{ ...data, district: data.district.id, email: data.email ?? '' }}
          onSubmit={onSubmit}
          mode="edit"
        />
      </PageLayout.Section>
    </Fragment>
  );
});
